import React, { useRef } from "react";
import { Grid, Button } from "@material-ui/core";

// styles
import useStyles from "./styles";

// components
import Widget from "../../Components/Widget";
import PageTitle from "../../Components/PageTitle";
import Miscellaneous from "../../Components/Miscellaneous/miscellaneous";
import TextMerger from "../../Components/TextMerger/TextMerger";
import UrlDecoder from "../../Components/UrlDecoder/UrlDecoder";
import Base64Decoder from "../../Components/Base64Decoder/Base64Decoder";
import JsonExporter from "../../Components/JsonExporter/JsonExporter";
import PunycodeDecoder from "../../Components/PunycodeDecoder/PunycodeDecoder";
import ParameterReporter from "../../Components/ParameterReporter/ParameterReporter";
import CriteoBlocklistExport from "../../Components/CriteoBlocklistExport/CriteoBlocklistExport";
import DomainBlockingToolConverter from "../../Components/DomainBlockingToolConverter/DomainBlockingToolConverter";

export default function MiscellaneousPage() {
  var classes = useStyles();

  const urlOpenerRef = useRef(null);
  const textMergerRef = useRef(null);
  const urlDecoderRef = useRef(null);
  const base64DecoderRef = useRef(null);
  const jsonExporterRef = useRef(null);
  const punycodeRef = useRef(null);
  const parameterReporterRef = useRef(null);
  const criteoBlocklistRef = useRef(null);
  const domainBlockingRef = useRef(null);

  const scrollTo = (ref) => ref.current.scrollIntoView({ behavior: "smooth", block: "start" });

  return (
    <>
      <PageTitle title="Miscellaneous Tools" />

      <div style={{ marginBottom: 16, display: "flex", flexWrap: "wrap", gap: 8 }}>
        <Button variant="contained" color="primary" onClick={() => scrollTo(urlOpenerRef)}>URL Opener</Button>
        <Button variant="contained" color="primary" onClick={() => scrollTo(textMergerRef)}>Text Merger</Button>
        <Button variant="contained" color="primary" onClick={() => scrollTo(domainBlockingRef)}>Domain Blocking Converter</Button>
        <Button variant="contained" color="primary" onClick={() => scrollTo(urlDecoderRef)}>URL Decoder</Button>
        <Button variant="contained" color="primary" onClick={() => scrollTo(base64DecoderRef)}>Base64 Decoder</Button>
        <Button variant="contained" color="primary" onClick={() => scrollTo(jsonExporterRef)}>Sellers.json Exporter</Button>
        <Button variant="contained" color="primary" onClick={() => scrollTo(punycodeRef)}>Punycode Converter</Button>
        <Button variant="contained" color="primary" onClick={() => scrollTo(parameterReporterRef)}>Parameter Reporter</Button>
        <Button variant="contained" color="primary" onClick={() => scrollTo(criteoBlocklistRef)}>Criteo Blocklist Export</Button>
      </div>

      <div ref={urlOpenerRef} />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget title="URL Opener" upperTitle bodyClass={classes.fullHeightBody} className={classes.card}>
            <Miscellaneous />
          </Widget>
        </Grid>
      </Grid>

      <div ref={textMergerRef} />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget title="Text Merger" upperTitle bodyClass={classes.fullHeightBody} className={classes.card}>
            <TextMerger />
          </Widget>
        </Grid>
      </Grid>

      <div ref={domainBlockingRef} />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget title="Domain Blocking Tool Converter" upperTitle bodyClass={classes.fullHeightBody} className={classes.card}>
            <DomainBlockingToolConverter />
          </Widget>
        </Grid>
      </Grid>

      <div ref={urlDecoderRef} />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget title="URL Decoder" upperTitle bodyClass={classes.fullHeightBody} className={classes.card}>
            <UrlDecoder />
          </Widget>
        </Grid>
      </Grid>

      <div ref={base64DecoderRef} />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget title="Base64 Decoder" upperTitle bodyClass={classes.fullHeightBody} className={classes.card}>
            <Base64Decoder />
          </Widget>
        </Grid>
      </Grid>

      <div ref={jsonExporterRef} />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget title="Sellers.json Exporter" upperTitle bodyClass={classes.fullHeightBody} className={classes.card}>
            <JsonExporter />
          </Widget>
        </Grid>
      </Grid>

      <div ref={punycodeRef} />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget title="Punycode to URL Converter" upperTitle bodyClass={classes.fullHeightBody} className={classes.card}>
            <PunycodeDecoder />
          </Widget>
        </Grid>
      </Grid>

      <div ref={parameterReporterRef} />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget title="Parameter Reporter" upperTitle bodyClass={classes.fullHeightBody} className={classes.card}>
            <ParameterReporter />
          </Widget>
        </Grid>
      </Grid>

      <div ref={criteoBlocklistRef} />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Widget title="Criteo Blocklist Export" upperTitle bodyClass={classes.fullHeightBody} className={classes.card}>
            <CriteoBlocklistExport />
          </Widget>
        </Grid>
      </Grid>
    </>
  );
}
